module.exports = __webpack_public_path__ + "img/close-icon.fb6fd5f3.svg";